// extracted by mini-css-extract-plugin
export default {"landingPage":"LandingPage_landingPage__hp8-o","main":"LandingPage_main__2z1Tm"};